import { SectionsProps } from 'containers/ContactsUtilsPage/types';
import { fromJS } from 'immutable';
import filter from 'lodash/filter';
import find from 'lodash/find';
import PAGES from 'routes/pages';
import {
  CLOSE_MODAL_SERVICES_AUTO,
  CLOSE_MODAL_SERVICES_MRH,
  GET_CONTACTS,
  GET_CONTACTS_FAILURE,
  GET_CONTACTS_SUCCESS,
  GET_FAQ,
  GET_FAQ_FAILED,
  GET_LAST_NOTIFICATION,
  GET_LAST_NOTIFICATION_FAILED,
  GET_LOCATIONS,
  GET_LOCATIONS_FAILURE,
  GET_LOCATIONS_SUCCESS,
  GET_VIMEO_THUMBNAIL_SRC,
  GET_VIMEO_THUMBNAIL_SRC_FAILED,
  GET_VIMEO_THUMBNAIL_SRC_SUCCESS,
  OPEN_MODAL_SERVICES_AUTO,
  OPEN_MODAL_SERVICES_MRH,
  REPORT_BUG,
  REPORT_BUG_FAIL,
  REPORT_BUG_SUCCESS,
  SET_AUTO_DETAILS_PAGE_BREADCRUMBS_PATH,
  SET_EPARGN_DETAILS_PAGE_BREADCRUMBS_PATH,
  SET_FAQ,
  SET_FAQ_SEARCHED,
  SET_LAST_NOTIFICATION,
  SET_MRH_DETAILS_PAGE_BREADCRUMBS_PATH,
  SET_NOTIFICATION_READ,
  SET_NOTIFICATION_READ_FAILED,
  SET_NOTIFICATION_READ_SUCCESS,
  SET_SELECTED_FAQ,
  SET_SELECTED_TAB,
  SET_TABS,
  SET_TOASTER_CLOSE,
  SET_TOASTER_OPEN,
  SET_AMC_DETAILS_PAGE_BREADCRUMBS_PATH,
  SET_ASI_DETAILS_PAGE_BREADCRUMBS_PATH,
} from 'store/global/constants';
import { GlobalActionType } from 'store/global/types';
import { hasFeature } from 'features/helpers';
import { FEATURES } from 'features/features';

export const initialState = fromJS({
  lastNotificationAUTO: null,
  lastNotificationMRH: null,
  lastNotificationASI: null,
  lastNotificationAMC: null,
  lastNotificationEPARGN: null,
  isLoading: false,
  hasError: null,
  autoDetailsPageBreadcrumbsPath: [
    { name: 'auto', route: PAGES.AUTODASHBOARD },
    { name: 'suiviDeSinistre' },
  ],
  mrhDetailsPageBreadcrumbsPath: [
    { name: 'habitation', route: PAGES.MRHDASHBOARD },
    { name: 'suiviDeSinistre' },
  ],
  epargnDetailsPageBreadcrumbsPath: [
    { name: 'epargn', route: PAGES.EPARGN_DASHBOARD },
    { name: 'mesReleveDeSituation' },
  ],
  amcDetailsPageBreadcrumbsPath: [
    { name: 'amc', route: PAGES.AMC_DASHBOARD },
    { name: 'mesRemboursements' },
  ],
  asiDetailsPageBreadcrumbsPath: [
    { name: 'asi', route: PAGES.ASI_DASHBOARD },
    { name: 'mesRemboursements' },
  ],
  vimeoThumbnailSrc: '',
  isLoadingVimeoThumbnailSrc: false,
  vimeoThumbnailSrcErrorMessage: '',
  tabs: [],
  toasterOpen: false,
  toaster: {
    open: false,
    title: '',
    subTitle: '',
    severity: '',
  },
  openModalServicesAuto: false,
  openModalServicesMrh: false,
  selectedTab: '',
  faq: '',
  isLoadingFaq: false,
  hasErrorIsLoadingFaq: null,
  isReportBugLoading: false,
  isLoadingLocations: false,
  locationsFilter: '',
  LocationsError: null,
  locations: [],
  searchedFAQ: [],
  contacts: [],
  isLoadingContacts: false,
  contactsErrors: '',
  SelectedCodeFaq: '',
  SelectedIdFaq: '',
});

const ADRESSES_UTILES = 'adresses_utiles';
const NUMEROS_ASSISTANCE = 'numeros_assistance';
const NUMEROS_SECOURS = 'numeros_secours';

const ASSISTANCE_FILTER = ['ServiceClientAuto', 'ServiceClientMRH'];
const ADRESSE_FILTER = ['check_auto_express', 'saham_agencies', 'garage_agree'];

const orderAndFilter = (contacts: SectionsProps[]): any => {
  const adresse = find(contacts, (item) => item.type === ADRESSES_UTILES);
  const assistance = find(contacts, (item) => item.type === NUMEROS_ASSISTANCE);
  const secours = find(contacts, (item) => item.type === NUMEROS_SECOURS);
  if (adresse && adresse.body && !hasFeature(FEATURES.UNIVERSE_AMC))
    adresse.body = filter(adresse.body, (item) =>
      ADRESSE_FILTER.includes(item.param),
    );
  if (assistance && assistance.body && !hasFeature(FEATURES.UNIVERSE_AMC))
    assistance.body = filter(assistance.body, (item) =>
      ASSISTANCE_FILTER.includes(item.key as string),
    );
  return [assistance, adresse, secours];
};

export default function reducer(
  state = initialState,
  action: GlobalActionType,
) {
  switch (action.type) {
    case GET_CONTACTS:
      return state
        .set('isLoadingContacts', true)
        .set('contactsError', null)
        .set('contacts', []);
    case GET_CONTACTS_FAILURE:
      return state
        .set('isLoadingContacts', false)
        .set('contactsError', action.payload);
    case GET_CONTACTS_SUCCESS: {
      return state
        .set('isLoadingContacts', false)
        .set('contactsError', null)
        .set('contacts', orderAndFilter(action.payload));
    }
    case GET_LOCATIONS:
      return state
        .set('isLoadingLocations', true)
        .set('LocationsError', null)
        .set('Locations', []);
    case GET_LOCATIONS_FAILURE:
      return state
        .set('isLoadingLocations', false)
        .set('LocationsError', action.payload);
    case GET_LOCATIONS_SUCCESS:
      return state
        .set('isLoadingLocations', false)
        .set('LocationsError', null)
        .set('locations', action.payload);
    case GET_LAST_NOTIFICATION:
      return state.set('isLoading', true).set('hasError', null);
    case SET_LAST_NOTIFICATION:
      return state
        .set(
          'lastNotification' + action.payload.section,
          action.payload.lastNotification,
        )
        .set('isLoading', false);
    case GET_LAST_NOTIFICATION_FAILED:
      return state.set('isLoading', false).set('hasError', true);
    case SET_NOTIFICATION_READ:
      return state.set('isLoading', true).set('hasError', null);
    case SET_NOTIFICATION_READ_SUCCESS:
      return state.set('lastNotification' + action.payload.section, null);
    case SET_NOTIFICATION_READ_FAILED:
      return state.set('isLoading', false).set('hasError', true);
    case SET_AUTO_DETAILS_PAGE_BREADCRUMBS_PATH:
      return state.set(
        'autoDetailsPageBreadcrumbsPath',
        fromJS(action.payload),
      );
    case SET_MRH_DETAILS_PAGE_BREADCRUMBS_PATH:
      return state.set('mrhDetailsPageBreadcrumbsPath', fromJS(action.payload));
    case SET_EPARGN_DETAILS_PAGE_BREADCRUMBS_PATH:
      return state.set(
        'epargnDetailsPageBreadcrumbsPath',
        fromJS(action.payload),
      );
    case SET_AMC_DETAILS_PAGE_BREADCRUMBS_PATH:
      return state.set('amcDetailsPageBreadcrumbsPath', fromJS(action.payload));
    case SET_ASI_DETAILS_PAGE_BREADCRUMBS_PATH:
      return state.set('asiDetailsPageBreadcrumbsPath', fromJS(action.payload));
    case GET_VIMEO_THUMBNAIL_SRC:
      return state
        .set('isLoadingVimeoThumbnailSrc', true)
        .set('vimeoThumbnailSrcErrorMessage', '');
    case GET_VIMEO_THUMBNAIL_SRC_SUCCESS:
      return state
        .set('vimeoThumbnailSrc', action.payload)
        .set('isLoadingVimeoThumbnailSrc', false);
    case GET_VIMEO_THUMBNAIL_SRC_FAILED:
      return state
        .set('vimeoThumbnailSrcErrorMessage', action.payload)
        .set('isLoadingVimeoThumbnailSrc', false);
    case SET_TABS:
      return state.set('tabs', action.payload);

    case SET_TOASTER_OPEN:
      return state
        .setIn(['toaster', 'open'], true)
        .setIn(['toaster', 'title'], action.payload.title)
        .setIn(['toaster', 'subTitle'], action.payload.subTitle)
        .setIn(['toaster', 'severity'], action.payload.severity);
    case SET_TOASTER_CLOSE:
      return state
        .setIn(['toaster', 'open'], false)
        .setIn(['toaster', 'title'], '')
        .setIn(['toaster', 'subTitle'], '');
    case OPEN_MODAL_SERVICES_AUTO:
      return state.set('openModalServicesAuto', true);
    case CLOSE_MODAL_SERVICES_AUTO:
      return state.set('openModalServicesAuto', false);
    case OPEN_MODAL_SERVICES_MRH:
      return state.set('openModalServicesMrh', true);
    case CLOSE_MODAL_SERVICES_MRH:
      return state.set('openModalServicesMrh', false);
    case SET_SELECTED_TAB:
      return state.set('selectedTab', action.payload);
    case GET_FAQ:
      return state.set('isLoadingFaq', true);
    case SET_FAQ:
      return state.set('faq', action.payload).set('isLoadingFaq', false);
    case GET_FAQ_FAILED:
      return state
        .set('hasErrorIsLoadingFaq', action.payload)
        .set('isLoadingFaq', false);
    case REPORT_BUG:
      return state.set('isReportBugLoading', true);
    case REPORT_BUG_SUCCESS:
      return state.set('isReportBugLoading', false);
    case REPORT_BUG_FAIL:
      return state.set('isReportBugLoading', false);
    case SET_FAQ_SEARCHED:
      return state.set('searchedFAQ', action.payload);
    case SET_SELECTED_FAQ:
      return state
        .set('SelectedCodeFaq', action.payload.code)
        .set('SelectedIdFaq', action.payload.id);
    default:
      return state;
  }
}
